import * as React from "react";
import Svg, { Polygon, Rect, Defs, G, Mask, Use } from "react-native-svg";

function PlusIconBuposOperator(props) {
  return (
    <Svg
      width={props.width || "40px"}
      height={props.height || "40px"}
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <Defs>
        <Rect id="path-1" x="0" y="0" width="29" height="29"></Rect>
      </Defs>
      <G
        id="icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <G id="Add" transform="translate(5.000000, 6.000000)">
          <Mask id="mask-2" fill="white">
            <Use xlinkHref="#path-1"></Use>
          </Mask>
          <G id="Rectangle"></G>
          <G
            mask="url(#mask-2)"
            fill={props.color || "#707070"}
            fillRule="nonzero"
            id="Union_1"
          >
            <Polygon points="12.6875 29.0018126 12.6875 16.3135196 0 16.3135196 0 12.688293 12.6875 12.688293 12.6875 0 16.3125 0 16.3125 12.688293 29 12.688293 29 16.3135196 16.3125 16.3135196 16.3125 29.0018126"></Polygon>
          </G>
        </G>
      </G>
    </Svg>
  );
}

export default PlusIconBuposOperator;
